import SvgArrow from '../../../images/SvgArrow';
const { RichText } = wp.blockEditor;

const Save = ({ attributes }) => {
  const { cardText, cardButtonHref, icon, isModal, variant } = attributes;
  const CustomTag = isModal ? 'button' : 'a';

  return (
    <CustomTag
      className={`SelfServiceCard__item ${
        isModal ? cardButtonHref : ''
      } ${variant}`}
      {...(!isModal && { href: cardButtonHref })}
    >
      {icon.src && (
        <figure className="SelfServiceCard__item--icon">
          <img src={icon.src} alt={icon.alt} height={icon.height} />
        </figure>
      )}

      <RichText.Content
        tagName="p"
        value={cardText}
        className="SelfServiceCard__item--text"
      />

      {variant === 'default' && (
        <div className="SelfServiceCard__item--arrow">
          <SvgArrow />
        </div>
      )}
    </CustomTag>
  );
};

export default Save;
